import { ENVInterface } from './common';

const Production: ENVInterface = {
    FRONT_ORIGIN: "https://oshi-challe.jp",
    API_ORIGIN: "https://api.oshi-challe.jp",
    API_CLNFIG: {
        validateStatus: (status: number) => {
            return true;
        },
        withCredentials: true,
    },
    GOOGLE_ANALYTICS: "UA-61304086-9",
    A8_PID: "s00000022246001",
};

export default Production;
